export default "__VITE_ASSET__BpJuc6xa__"